module.exports = __webpack_public_path__ + "img/header_bg.2ebcded.png";